<div class="modal-header bg-dark text-center">
    <h4 class="modal-title">Creazione Nuovo <strong>Fornitore</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body" style="margin-bottom: 10px;">
    <p class="section-title">Dati Fornitore</p>

    <div class="form-group">
        <label for="name" class="col-sm-3 control-label form-label-aligned m-b-20">Nome</label>
        <div class="col-sm-9 prepend-icon m-b-20">
            <input type="text"
                   id="name"
                   name="name"
                   class="form-control"
                   placeholder="Inserisci nome del fornitore"
                   autocomplete="off"
                   [(ngModel)]="supplier.Name">
            <i class="icon-drawer"></i>
        </div>
    </div>

    <div class="form-group">
        <label for="cf" class="col-sm-3 control-label form-label-aligned m-b-20">Codice Fiscale</label>
        <div class="col-sm-9 field-column m-b-20">
            <div class="prepend-icon">
                <input type="text"
                       id="cf"
                       name="cf"
                       class="form-control"
                       placeholder="Inserisci codice fiscale"
                       autocomplete="off"
                       [(ngModel)]="supplier.CF">
                <i class="icon-list"></i>
            </div>
            <mat-checkbox class="foreign-toggle" color="primary" name="foreign-supplier" [(ngModel)]="foreignSupplier">Fornitore estero</mat-checkbox>
            <span class="field-hint" *ngIf="!foreignSupplier">Formato italiano: 11 cifre per una società, 16 caratteri per una persona fisica.</span>
            <span class="field-hint" *ngIf="foreignSupplier">Inserisci l'identificativo fiscale del paese del fornitore.</span>
            <span class="field-error" *ngIf="cfError">{{ cfError }}</span>
        </div>
    </div>

    <div class="form-group">
        <label for="email-0" class="col-sm-3 control-label form-label-aligned m-b-20">Email</label>
        <div class="col-sm-9 field-column m-b-20">
            <div class="email-list-container">
                <div class="email-input-row" *ngFor="let email of emails; let i = index; trackBy: trackByIndex">
                    <div class="prepend-icon email-input-wrapper">
                        <input type="email"
                               [id]="'email-' + i"
                               [name]="'email-' + i"
                               class="form-control"
                               [class.input-error]="hasEmailItemError(i)"
                               [placeholder]="emails.length > 1 ? 'Inserisci indirizzo email ' + (i + 1) : 'Inserisci indirizzo email'"
                               autocomplete="off"
                               [(ngModel)]="emails[i]"
                               (ngModelChange)="onEmailChange(i, $event)">
                        <i class="icon-envelope"></i>
                    </div>
                    <button type="button"
                            class="btn btn-sm btn-danger email-remove-btn"
                            (click)="removeEmail(i)"
                            [disabled]="emails.length === 1"
                            title="Rimuovi indirizzo email"
                            aria-label="Rimuovi indirizzo email">
                        <i class="fa fa-trash-o"></i>
                    </button>
                </div>
            </div>
            <div class="email-actions">
                <button type="button"
                        class="btn btn-sm btn-default email-add-btn"
                        (click)="addEmail()">
                    <i class="fa fa-plus"></i> Aggiungi email
                </button>
            </div>
            <span class="field-hint">Usa il pulsante "Aggiungi email" per inserire più indirizzi per questo fornitore.</span>
            <span class="field-error" *ngIf="emailFieldError">{{ emailFieldError }}</span>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-blue btn-embossed" (click)="createSupplier()">Crea</button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.close()">Chiudi</button>
</div>
